'use strict';
var _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PZAttribute = function PZAttribute(props) {
    var tabdata = props.pzSubTab ? props.pzSubTab : props.pzTab;
    var tabAttributes = props.pzCustomizer.attributes[tabdata.promize_tab_id] ? props.pzCustomizer.attributes[tabdata.promize_tab_id] : {};
    var pzTabAttrText = null,
        pzTabAttrImage = null,
        objKey = null;
    var textSize = 28,
        textSpace = 20,
        imageSpace = 20;
    var pzCanvasObject = props.pzCanvasObject;
    var pzAttrTextObj = {},
        pzAttrImageObj = {};
    var pzTextTabAttrId = 0;
    return React.createElement(
        React.Fragment,
        null,
        Object.keys(tabAttributes).length > 0 && Object.keys(tabAttributes).map(function(tab_attr, tab_attr_index) {
            if (!props.pzHideAttributes.includes(parseInt(tab_attr))) {
                if (props.pzCustomizer.attributeOptions[tab_attr]) {
                    return React.createElement(PromizeOption, _extends({
                        tabAttribute: tab_attr,
                        pzOptions: props.pzCustomizer.attributeOptions[tab_attr],
                        pzAttribute: tabAttributes[tab_attr]
                    }, props));
                } else if (props.pzCustomizer.attributeTexts[tab_attr] && Object.keys(props.pzCustomizer.attributeDomainTexts).length > 0) {
                    pzTabAttrText = props.pzCustomizer.attributeTexts[tab_attr];
                    objKey = 'FObject_text_' + pzTabAttrText.promize_tab_attribute_id + '_0';
                    pzTextTabAttrId = tab_attr;
                    if (pzCanvasObject[objKey]) {
                        //console.log("coming here")
                        textSize = pzCanvasObject[objKey].fontSize;
                        textSpace = pzCanvasObject[objKey].objectSpacing;
                    }
                    /* else {
                        if (props.AttributeComponent.state.pzTextSpacing && objKey in props.AttributeComponent.state.pzTextSpacing) {
                            textSpace = parseInt(props.AttributeComponent.state.pzTextSpacing[objKey]);
                        }
                        if (props.AttributeComponent.state.pzTextSize && objKey in props.AttributeComponent.state.pzTextSize) {
                            textSize = parseInt(props.AttributeComponent.state.pzTextSize[objKey]);
                        }
                    } */
                    pzAttrTextObj = _defineProperty({}, tab_attr, {
                        'textSize': textSize,
                        'textSpace': textSpace
                    });
                    return React.createElement(PromizeText, _extends({
                        tabAttribute: tab_attr,
                        pzTexts: props.pzCustomizer.attributeTexts[tab_attr]
                    }, props, {
                        pzAttrTextObj: pzAttrTextObj
                    }));
                } else if (props.pzCustomizer.attributeImages[tab_attr]) {
                    pzTabAttrImage = props.pzCustomizer.attributeImages[tab_attr];
                    var canvasObj = props.HomeComponent.pzCanvasObjectGetItemByFieldName('tabAttrId', tab_attr);
                    //console.log("PZATTR ", canvasObj)
                    /*
                    let uploadImageCount = props.HomeComponent.pzSendIncrementValueByType('image', false);
                    objKey = "FObject_image_" + tab_attr + '_' + uploadImageCount + '_' + uploadImageCount;
                    */
                    if (canvasObj && canvasObj.customType == "uploadimage") {
                        imageSpace = canvasObj.objectSpacing;
                    }
                    /* if (pzCanvasObject[objKey]) {
                        imageSpace = pzCanvasObject[objKey].objectSpacing;
                    } */
                    else {
                        if (props.AttributeComponent.state.pzImageSpacing && objKey in props.AttributeComponent.state.pzImageSpacing) {
                            imageSpace = parseInt(props.AttributeComponent.state.pzImageSpacing[objKey]);
                        }
                    }
                    pzAttrImageObj = _defineProperty({}, tab_attr, {
                        'imageSpace': imageSpace
                    });
                    var pzTabAdditionalData = tabdata.additional_data ? JSON.parse(tabdata.additional_data) : '';
                    return React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(PromizeUploadImage, _extends({
                            tabAttribute: tab_attr,
                            pzUploadImage: props.pzCustomizer.attributeImages[tab_attr],
                            pzAttribute: tabAttributes[tab_attr]
                        }, props, {
                            pzAttrImageObj: pzAttrImageObj
                        })),
                        pzTabAdditionalData && (pzTabAdditionalData.tab_code == "back_text_image" || pzTabAdditionalData.tab_code == "front_text_image") && React.createElement(
                            'div', {
                                className: 'pz-slider-container'
                            },
                            React.createElement(
                                'div', {
                                    className: 'pz-text-slider'
                                },
                                React.createElement(
                                    'span',
                                    null,
                                    'Text Size'
                                ),
                                React.createElement('input', {
                                    type: 'range',
                                    value: pzAttrTextObj[pzTextTabAttrId] ? pzAttrTextObj[pzTextTabAttrId]['textSize'] : textSize,
                                    min: '28',
                                    max: '200',
                                    onChange: function onChange(e) {
                                        props.AttributeComponent.pzTextSlider(e, pzTabAttrText, "text");
                                    }
                                })
                            ),
                            React.createElement(
                                'div', {
                                    className: 'pz-text-slider'
                                },
                                React.createElement(
                                    'span',
                                    null,
                                    'Text Spacing'
                                ),
                                React.createElement('input', {
                                    type: 'range',
                                    value: pzAttrTextObj[pzTextTabAttrId] ? pzAttrTextObj[pzTextTabAttrId]['textSpace'] : textSpace,
                                    min: '20',
                                    max: '200',
                                    onChange: function onChange(e) {
                                        props.AttributeComponent.pzTextSlider(e, pzTabAttrText, "text", 'objectSpacing');
                                    }
                                })
                            ),
                            React.createElement(
                                'div', {
                                    className: 'pz-text-slider'
                                },
                                React.createElement(
                                    'span',
                                    null,
                                    'Image Spacing'
                                ),
                                React.createElement('input', {
                                    type: 'range',
                                    value: pzAttrImageObj[tab_attr] ? pzAttrImageObj[tab_attr]['imageSpace'] : imageSpace,
                                    min: '20',
                                    max: '200',
                                    onChange: function onChange(e) {
                                        props.AttributeComponent.pzImageSpacingSlider(e, pzTabAttrImage, "image");
                                    }
                                })
                            )
                        )
                    );
                }
            }
        })
    );
};
